import { render, staticRenderFns } from "./CommonHeader.vue?vue&type=template&id=4c497d2c&scoped=true"
import script from "./CommonHeader.vue?vue&type=script&lang=js"
export * from "./CommonHeader.vue?vue&type=script&lang=js"
import style0 from "./CommonHeader.vue?vue&type=style&index=0&id=4c497d2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c497d2c",
  null
  
)

export default component.exports